import FlowComponent from './FlowComponent';

export default FlowComponent;
